import {
  stopWaitingForExpectedRequestFromRocket,
  waitForExpectedRequestFromRocket,
} from './messaging';

const READY_REQUEST = {
  name: 'notification',
  subject: 'readyToReceiveRequests',
} as const;

const getRocketIFrame = () => {
  const iFrame = window?.document?.getElementById('volman-rocket-iframe') as HTMLIFrameElement;
  if (!iFrame) {
    console.warn('Unable to get rocket iframe');
  }
  return iFrame;
};

export async function waitForReadyNofificationFromRocket() {
  await waitForExpectedRequestFromRocket(getRocketIFrame(), READY_REQUEST);
}

export function stopWaitingForReadyNotificationFromRocket() {
  stopWaitingForExpectedRequestFromRocket(READY_REQUEST);
}
